<div class="interest-selector" data-cy="VoorkeurenSelecties">
    <mat-chip-list [multiple]="true"
                   [selectable]="true"
                   class="interest-selector__chip-list"
                   data-cy="chip-list">
        <mat-basic-chip *ngFor="let interest of interests"
                        data-cy="VoorkeurenSelectieChip"
                        #chip="matChip"
                        (click)="mode === 'read-only' ? return : (interest.selected ? chip.deselect() : chip.selectViaInteraction()); handleChipClick(interest)"
                        [selected]="interest.selected"
                        [selectable]="mode !== 'read-only'"
                        (selectionChange)="changeSelected($event, interest)"
                        class="interest-selector__chip"
                        [ngClass]="{'interest-selector__chip--selected': interest.selected}">
            <p class="interest-selector__name">{{interest.name}}</p>
            <mat-icon (click)="handleChipClick(interest)" *ngIf="mode === 'filter'" matChipRemove>cancel</mat-icon>
        </mat-basic-chip>
    </mat-chip-list>
</div>
